export default "__VITE_ASSET__DIemVGsV__"